module.exports = [
	{
		"fund_id": "FSUSA00B4O",
		"investment_vehicle_id": "FEUSA0000E",
		"ticker": "IVV",
		"fund_legal_name": "iShares Core S&P 500 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 642513921836,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 2,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07905311230441378,
		"cl_weight": 0.2598663836252108,
		"fossil_bank_score": 31.0338,
		"fossil_insure_score": 20.6164,
		"wff_mil_weight": 0.03757014438462011,
		"mmc_weight": 0.03757014438462011,
		"cm_weight": 0.014578122192606206,
		"nw_weight": 0.024790742854398237,
		"wff_civ_weight": 0.009311049857256188,
		"gm_weight": 0.0014489858631601368,
		"gr_weight": 0.007862063994096051,
		"t_all_weight": 0.016759049203066884,
		"to_weight": 0.006680167538178325,
		"tm_weight": 0.010078881664888559,
		"po_producer_weight": 0.0015708944354994147,
		"po_financier_weight": 0.027561657124837873,
		"po_consumer_weight": 0.11126607172690396,
		"pp_weight": 0.19942618811550344,
		"borders_weight": 0.1892300898297175,
		"pp_high_weight": 0.003206542790141011,
		"borders_high_weight": 0.019985142633359175,
		"pff_all_weight": 0.23140978696971104,
		"pff_all_high_weight": 0.019985142633359175,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 54.7397840162493,
		"gef_score_a": 26.34799419525372,
		"gef_score_b": 9.33548511866141,
		"gef_score_c": 18.37567149248441,
		"gef_score_d": 0.6806332098413019,
		"gef_score_a_norm": 65.86998548813429,
		"gef_score_b_norm": 31.118283728871365,
		"gef_score_c_norm": 91.87835746242206,
		"gef_score_d_norm": 6.806332098413019,
		"prospectus_net_expense_ratio": 0.03,
		"trailing_return_m1": 2.24202,
		"trailing_return_m3": 14.19925,
		"trailing_return_m6": 5.62831,
		"trailing_return_y1": 16.29498,
		"trailing_return_y3": 17.07258,
		"trailing_return_y5": 15.84633,
		"trailing_return_y10": 13.62423,
		"trailing_return_y15": 14.46245,
		"trailing_return_y20": 10.60495,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "S&P 500",
		"footprint": 85.50252511049075,
		"intensity": 173.1109655083947,
		"name": "IVV - iShares Core S&P 500 ETF",
		"label": "IVV - iShares Core S&P 500 ETF"
	},
	{
		"fund_id": "FSUSA00B5E",
		"investment_vehicle_id": "FEUSA00014",
		"ticker": "IWV",
		"fund_legal_name": "iShares Russell 3000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 16208779386,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 4,
		"grade_rji": 4,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07721798886547203,
		"cl_weight": 0.22819319602501378,
		"fossil_bank_score": 27.3802,
		"fossil_insure_score": 18.3056,
		"wff_mil_weight": 0.03939897323032038,
		"mmc_weight": 0.03939897323032038,
		"cm_weight": 0.014024660524809583,
		"nw_weight": 0.0244352484148063,
		"wff_civ_weight": 0.008556821714710524,
		"gm_weight": 0.0013333570262988486,
		"gr_weight": 0.0072234646884116755,
		"t_all_weight": 0.01472969526200222,
		"to_weight": 0.005924834282753748,
		"tm_weight": 0.00880486097924847,
		"po_producer_weight": 0.0013731853338522612,
		"po_financier_weight": 0.024263581559815374,
		"po_consumer_weight": 0.09977649306229264,
		"pp_weight": 0.17738075930201253,
		"borders_weight": 0.16916172959310932,
		"pp_high_weight": 0.0031295323772338795,
		"borders_high_weight": 0.01877740647948448,
		"pff_all_weight": 0.20695092883805058,
		"pff_all_high_weight": 0.018786042534367754,
		"pff_all_extreme_weight": 0.00008999477232388055,
		"gef_score_norm": 53.19592357729898,
		"gef_score_a": 25.748584555572393,
		"gef_score_b": 8.77739895584033,
		"gef_score_c": 18.05301484147519,
		"gef_score_d": 0.6169252244034588,
		"gef_score_a_norm": 64.37146138893098,
		"gef_score_b_norm": 29.257996519467767,
		"gef_score_c_norm": 90.26507420737595,
		"gef_score_d_norm": 6.169252244034587,
		"prospectus_net_expense_ratio": 0.2,
		"trailing_return_m1": 2.18327,
		"trailing_return_m3": 14.13658,
		"trailing_return_m6": 4.67119,
		"trailing_return_y1": 15.45784,
		"trailing_return_y3": 16.22449,
		"trailing_return_y5": 14.99509,
		"trailing_return_y10": 12.83084,
		"trailing_return_y15": 13.92525,
		"trailing_return_y20": 10.25989,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell 3000",
		"footprint": 97.39973655355976,
		"intensity": 177.28587948168712,
		"name": "IWV - iShares Russell 3000 ETF",
		"label": "IWV - iShares Russell 3000 ETF"
	},
	{
		"fund_id": "FSUSA00B5H",
		"investment_vehicle_id": "FEUSA00017",
		"ticker": "IWM",
		"fund_legal_name": "iShares Russell 2000 ETF",
		"morningstar_category_name": "Small Blend",
		"fund_net_assets": 60629923115,
		"grade_fossil": 4,
		"grade_deforestation": 2,
		"grade_tobacco": 3,
		"grade_gender_equality": 5,
		"grade_dei": 5,
		"grade_rji": 5,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 4,
		"grade_guns": 3,
		"c2f5coogutweight": 0.0700618601291163,
		"cl_weight": 0.003222378396869585,
		"fossil_bank_score": 0,
		"fossil_insure_score": 0,
		"wff_mil_weight": 0.036731331611819386,
		"mmc_weight": 0.036731331611819386,
		"cm_weight": 0.0038789757563992672,
		"nw_weight": 0.012495228684530629,
		"wff_civ_weight": 0.0019273036319784258,
		"gm_weight": 0.0006176647194764197,
		"gr_weight": 0.0013096389125020062,
		"t_all_weight": 0.0015575086398992776,
		"to_weight": 0.001068821986939552,
		"tm_weight": 0.0004886866529597257,
		"po_producer_weight": 0,
		"po_financier_weight": 0,
		"po_consumer_weight": 0.0035110668826543383,
		"pp_weight": 0.004896994837654089,
		"borders_weight": 0.010573724577631873,
		"pp_high_weight": 0.0028818743635661203,
		"borders_high_weight": 0.004279943240970523,
		"pff_all_weight": 0.012798010499040596,
		"pff_all_high_weight": 0.004489108688291275,
		"pff_all_extreme_weight": 0.002212978298477387,
		"gef_score_norm": 37.58115642234888,
		"gef_score_a": 19.203706368379596,
		"gef_score_b": 3.3330600141330136,
		"gef_score_c": 15.013667229633331,
		"gef_score_d": 0.030722810208177544,
		"gef_score_a_norm": 48.00926592094899,
		"gef_score_b_norm": 11.110200047110046,
		"gef_score_c_norm": 75.06833614816667,
		"gef_score_d_norm": 0.3072281020817754,
		"prospectus_net_expense_ratio": 0.19,
		"trailing_return_m1": 1.71429,
		"trailing_return_m3": 12.92023,
		"trailing_return_m6": -2.67003,
		"trailing_return_y1": -0.67089,
		"trailing_return_y3": 6.91047,
		"trailing_return_y5": 9.68487,
		"trailing_return_y10": 7.36862,
		"trailing_return_y15": 9.94484,
		"trailing_return_y20": 7.49736,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell 2000",
		"footprint": 175.68163166512545,
		"intensity": 149.69572190373236,
		"name": "IWM - iShares Russell 2000 ETF",
		"label": "IWM - iShares Russell 2000 ETF"
	},
	{
		"fund_id": "FSUSA00B5K",
		"investment_vehicle_id": "FEUSA0001A",
		"ticker": "IWB",
		"fund_legal_name": "iShares Russell 1000 ETF",
		"morningstar_category_name": "Large Blend",
		"fund_net_assets": 42201823469,
		"grade_fossil": 4,
		"grade_deforestation": 3,
		"grade_tobacco": 4,
		"grade_gender_equality": 4,
		"grade_dei": 3,
		"grade_rji": 3,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 4,
		"grade_military": 4,
		"grade_guns": 4,
		"c2f5coogutweight": 0.07751331534181394,
		"cl_weight": 0.23780754190620873,
		"fossil_bank_score": 28.5527,
		"fossil_insure_score": 19.0909,
		"wff_mil_weight": 0.03942937067125599,
		"mmc_weight": 0.03942937067125599,
		"cm_weight": 0.014461346297367185,
		"nw_weight": 0.02490378837956377,
		"wff_civ_weight": 0.00882779978450031,
		"gm_weight": 0.001368524809292457,
		"gr_weight": 0.00745927497520785,
		"t_all_weight": 0.01530170894917678,
		"to_weight": 0.006131020468110085,
		"tm_weight": 0.009170688481066693,
		"po_producer_weight": 0.001436855510922775,
		"po_financier_weight": 0.02530015186035839,
		"po_consumer_weight": 0.10390618392751833,
		"pp_weight": 0.18473039785598283,
		"borders_weight": 0.1759055728926003,
		"pp_high_weight": 0.0031423075013729345,
		"borders_high_weight": 0.019391641559670318,
		"pff_all_weight": 0.21520572488980763,
		"pff_all_high_weight": 0.019391641559670318,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 53.65421656728627,
		"gef_score_a": 25.940104640350892,
		"gef_score_b": 8.938151923123183,
		"gef_score_c": 18.141562816427,
		"gef_score_d": 0.6343971873772252,
		"gef_score_a_norm": 64.85026160087723,
		"gef_score_b_norm": 29.793839743743945,
		"gef_score_c_norm": 90.707814082135,
		"gef_score_d_norm": 6.343971873772252,
		"prospectus_net_expense_ratio": 0.15,
		"trailing_return_m1": 2.2103,
		"trailing_return_m3": 14.21032,
		"trailing_return_m6": 5.05131,
		"trailing_return_y1": 16.35931,
		"trailing_return_y3": 16.7895,
		"trailing_return_y5": 15.33484,
		"trailing_return_y10": 13.23465,
		"trailing_return_y15": 14.24561,
		"trailing_return_y20": 10.48971,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "Russell 1000",
		"footprint": 93.63257600207086,
		"intensity": 180.5763346449502,
		"name": "IWB - iShares Russell 1000 ETF",
		"label": "IWB - iShares Russell 1000 ETF"
	},
	{
		"fund_id": "FSUSA00B7C",
		"investment_vehicle_id": "FEUSA0002W",
		"ticker": "EFA",
		"fund_legal_name": "iShares MSCI EAFE ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 63947666044,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.10967169416870241,
		"cl_weight": 0.1280541842437636,
		"fossil_bank_score": 30.8449,
		"fossil_insure_score": 22.28,
		"wff_mil_weight": 0.05116719730516077,
		"mmc_weight": 0.05116719730516077,
		"cm_weight": 0.02510995420940458,
		"nw_weight": 0.027668324476688842,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.016961116197823728,
		"to_weight": 0.008997640193109691,
		"tm_weight": 0.007963476004714039,
		"po_producer_weight": 0.014465023143950559,
		"po_financier_weight": 0.08651369801905498,
		"po_consumer_weight": 0.10146014529645456,
		"pp_weight": 0.015221605804504835,
		"borders_weight": 0.03153741591002699,
		"pp_high_weight": 0.0008219724377861953,
		"borders_high_weight": 0.007112705661178682,
		"pff_all_weight": 0.033930818894489824,
		"pff_all_high_weight": 0.007934678098964877,
		"pff_all_extreme_weight": 0.0002780974515383648,
		"gef_score_norm": 58.10612688136981,
		"gef_score_a": 25.62642816735623,
		"gef_score_b": 13.668101495364558,
		"gef_score_c": 17.48917221644115,
		"gef_score_d": 1.322425002200718,
		"gef_score_a_norm": 64.06607041839058,
		"gef_score_b_norm": 45.56033831788186,
		"gef_score_c_norm": 87.44586108220575,
		"gef_score_d_norm": 13.224250022007181,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": -2.5239,
		"trailing_return_m3": 4.51994,
		"trailing_return_m6": 11.85778,
		"trailing_return_y1": 11.92092,
		"trailing_return_y3": 13.02773,
		"trailing_return_y5": 10.21532,
		"trailing_return_y10": 6.04712,
		"trailing_return_y15": 6.65731,
		"trailing_return_y20": 5.48402,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "MSCI EAFE",
		"footprint": 166.34779529488438,
		"intensity": 200.12888979498774,
		"name": "EFA - iShares MSCI EAFE ETF",
		"label": "EFA - iShares MSCI EAFE ETF"
	},
	{
		"fund_id": "FSUSA04C4U",
		"investment_vehicle_id": "FEUSA04ABV",
		"ticker": "EEM",
		"fund_legal_name": "iShares MSCI Emerging Markets ETF",
		"morningstar_category_name": "Diversified Emerging Mkts",
		"fund_net_assets": 18734853188,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 3,
		"grade_gender_equality": -1,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 1,
		"grade_military": 4,
		"grade_guns": 1,
		"c2f5coogutweight": 0.09530876938132996,
		"cl_weight": 0.1398159260686557,
		"fossil_bank_score": 8.3431,
		"fossil_insure_score": 7.4149,
		"wff_mil_weight": 0.033584059505130055,
		"mmc_weight": 0.033584059505130055,
		"cm_weight": 0.006246493901301836,
		"nw_weight": 0.017273292336720487,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.00323492830676115,
		"to_weight": 0.00323492830676115,
		"tm_weight": 0,
		"po_producer_weight": 0.010481481385911678,
		"po_financier_weight": 0.018599585505190596,
		"po_consumer_weight": 0.009224354474816721,
		"pp_weight": 0,
		"borders_weight": 0,
		"pp_high_weight": 0,
		"borders_high_weight": 0,
		"pff_all_weight": 0,
		"pff_all_high_weight": 0,
		"pff_all_extreme_weight": 0,
		"gef_score_norm": 47.044034776722164,
		"gef_score_a": 22.331159825358935,
		"gef_score_b": 7.5209109696565095,
		"gef_score_c": 16.561496763986213,
		"gef_score_d": 0.6304672177277025,
		"gef_score_a_norm": 55.82789956339733,
		"gef_score_b_norm": 25.069703232188367,
		"gef_score_c_norm": 82.80748381993106,
		"gef_score_d_norm": 6.304672177277025,
		"prospectus_net_expense_ratio": 0.72,
		"trailing_return_m1": 1.32448,
		"trailing_return_m3": 12.19094,
		"trailing_return_m6": 14.98174,
		"trailing_return_y1": 16.42643,
		"trailing_return_y3": 9.65971,
		"trailing_return_y5": 4.59966,
		"trailing_return_y10": 5.09304,
		"trailing_return_y15": 3.31545,
		"trailing_return_y20": 5.38377,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "MSCI Emerging Markets",
		"footprint": 314.88973634654246,
		"intensity": 411.7265809951513,
		"name": "EEM - iShares MSCI Emerging Markets ETF",
		"label": "EEM - iShares MSCI Emerging Markets ETF"
	},
	{
		"fund_id": "FSUSA08N98",
		"investment_vehicle_id": "FOUSA06OEY",
		"ticker": "ACWX",
		"fund_legal_name": "iShares MSCI ACWI ex U.S. ETF",
		"morningstar_category_name": "Foreign Large Blend",
		"fund_net_assets": 6402992789,
		"grade_fossil": 5,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 2,
		"grade_dei": -1,
		"grade_rji": -1,
		"grade_hrc": -1,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 1,
		"c2f5coogutweight": 0.1154540373076129,
		"cl_weight": 0.1288827750525136,
		"fossil_bank_score": 31.3248,
		"fossil_insure_score": 17.3235,
		"wff_mil_weight": 0.0449501873838676,
		"mmc_weight": 0.0449501873838676,
		"cm_weight": 0.01769031180932298,
		"nw_weight": 0.025188925439894715,
		"wff_civ_weight": 0,
		"gm_weight": 0,
		"gr_weight": 0,
		"t_all_weight": 0.01165797900667885,
		"to_weight": 0.006648440379854525,
		"tm_weight": 0.005009538626824328,
		"po_producer_weight": 0.01205801947974096,
		"po_financier_weight": 0.059933318857202746,
		"po_consumer_weight": 0.06763998801370129,
		"pp_weight": 0.0113006646703789,
		"borders_weight": 0.020748839506289023,
		"pp_high_weight": 0.0005032394333063731,
		"borders_high_weight": 0.005488128234282209,
		"pff_all_weight": 0.024092237138516687,
		"pff_all_high_weight": 0.0059913676675885826,
		"pff_all_extreme_weight": 0.0001744450529519554,
		"gef_score_norm": 56.95236105771472,
		"gef_score_a": 25.503929622139186,
		"gef_score_b": 12.780646757856873,
		"gef_score_c": 17.451610758345126,
		"gef_score_d": 1.2161739193669567,
		"gef_score_a_norm": 63.75982405534797,
		"gef_score_b_norm": 42.60215585952291,
		"gef_score_c_norm": 87.25805379172563,
		"gef_score_d_norm": 12.161739193669566,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": -1.2047,
		"trailing_return_m3": 7.11309,
		"trailing_return_m6": 12.91741,
		"trailing_return_y1": 14.0229,
		"trailing_return_y3": 12.14558,
		"trailing_return_y5": 8.87336,
		"trailing_return_y10": 5.93385,
		"trailing_return_y15": 5.81113,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "MSCI ACWI ex U.S.",
		"footprint": 209.78019554956103,
		"intensity": 263.09407571940983,
		"name": "ACWX - iShares MSCI ACWI ex U.S. ETF",
		"label": "ACWX - iShares MSCI ACWI ex U.S. ETF"
	},
	{
		"fund_id": "FSUSA08N99",
		"investment_vehicle_id": "FOUSA06OEZ",
		"ticker": "ACWI",
		"fund_legal_name": "iShares MSCI ACWI ETF",
		"morningstar_category_name": "Global Large-Stock Blend",
		"fund_net_assets": 22084154899,
		"grade_fossil": 4,
		"grade_deforestation": 4,
		"grade_tobacco": 4,
		"grade_gender_equality": 3,
		"grade_dei": 2,
		"grade_rji": 2,
		"grade_hrc": 3,
		"grade_prison_industrial_complex": 5,
		"grade_military": 5,
		"grade_guns": 3,
		"c2f5coogutweight": 0.08846021998617691,
		"cl_weight": 0.20735756542446435,
		"fossil_bank_score": 30.9389,
		"fossil_insure_score": 16.384,
		"wff_mil_weight": 0.04046054229381115,
		"mmc_weight": 0.04046054229381115,
		"cm_weight": 0.015908540607047106,
		"nw_weight": 0.024766060654951186,
		"wff_civ_weight": 0.00608573627713838,
		"gm_weight": 0.0009066378879462298,
		"gr_weight": 0.005179098389192151,
		"t_all_weight": 0.014543274744684968,
		"to_weight": 0.0065578409950990705,
		"tm_weight": 0.0079854337495859,
		"po_producer_weight": 0.005146213856653637,
		"po_financier_weight": 0.03885553025888942,
		"po_consumer_weight": 0.09387354190506138,
		"pp_weight": 0.12544234955666245,
		"borders_weight": 0.1253630194766415,
		"pp_high_weight": 0.0022257106107874554,
		"borders_high_weight": 0.014717197416544932,
		"pff_all_weight": 0.15043177180341438,
		"pff_all_high_weight": 0.014894212853268796,
		"pff_all_extreme_weight": 0.00006244677687897213,
		"gef_score_norm": 55.07784333794432,
		"gef_score_a": 25.96609047657933,
		"gef_score_b": 10.220116961576155,
		"gef_score_c": 18.082211751328074,
		"gef_score_d": 0.8094241484528985,
		"gef_score_a_norm": 64.91522619144831,
		"gef_score_b_norm": 34.06705653858718,
		"gef_score_c_norm": 90.41105875664037,
		"gef_score_d_norm": 8.094241484528984,
		"prospectus_net_expense_ratio": 0.32,
		"trailing_return_m1": 1.02074,
		"trailing_return_m3": 11.74755,
		"trailing_return_m6": 7.92688,
		"trailing_return_y1": 15.69697,
		"trailing_return_y3": 15.15427,
		"trailing_return_y5": 12.76822,
		"trailing_return_y10": 10.16934,
		"trailing_return_y15": 10.24093,
		"trailing_return_y20": -1000,
		"performance_as_of_date": "2025-07-31T00:00:00.000Z",
		"index_name": "MSCI ACWI",
		"footprint": 132.11577835385125,
		"intensity": 218.71048453380192,
		"name": "ACWI - iShares MSCI ACWI ETF",
		"label": "ACWI - iShares MSCI ACWI ETF"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/CoreBenchmarks.json
// module id = 947
// module chunks = 0